import { BooleanDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { DateGreaterThanExpression } from "../../../rule-engine-core/Expressions/Expressions/Date/DateGreaterThanExpression";
import { ExistsExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/Exists";
import { IsTrueExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/IsTrue";
import { NotExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/NotExpression";
import { StringContainsExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringContainsExpression";
import { TreeRuleConfiguration } from "../../../rule-engine-core/Rule/Tree/TreeRuleConfiguration";
import { getTestInputDataDefinition } from "../DataDefinition";

export const getTreeRuleEmpty = (): TreeRuleConfiguration => {
    const treeRule = new TreeRuleConfiguration();
    treeRule.inputData = getTestInputDataDefinition();
    return treeRule;
};

export const getTreeRuleExample = (): TreeRuleConfiguration => {
    const treeRule = new TreeRuleConfiguration();
    treeRule.inputData = getTestInputDataDefinition();
    treeRule.executionResult = new BooleanDataDefinition();

    treeRule.root.setupEvaluation(treeRule.getInputDefinition());
    treeRule.root.expression.variableName = "isManager";

    let node = treeRule.root.trueNode!;
    node.setupEvaluation(treeRule.getInputDefinition());

    let notExp = new NotExpression();

    let exists = new ExistsExpression();
    exists.dataPath = "disciplinaryActionsHistory";

    notExp.value1.subExpression = exists;
    node.expression.expression = notExp;

    node.falseNode!.setupResult(treeRule.getInputDefinition(), treeRule.getRuleResult());
    node.falseNode!.expression.value = false;

    node = node.trueNode!;

    node.setupEvaluation(treeRule.getInputDefinition());
    let isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "fullTime";
    node.expression.expression = isTrue;

    node.falseNode!.setupResult(treeRule.getInputDefinition(), treeRule.getRuleResult());
    node.falseNode!.expression.value = false;

    node.trueNode!.setupResult(treeRule.getInputDefinition(), treeRule.getRuleResult());
    node.trueNode!.expression.value = false;

    node = treeRule.root.falseNode!;
    node.setupEvaluation(treeRule.getInputDefinition());

    let greaterThan = new DateGreaterThanExpression();
    greaterThan.value1.variableName = "dateOfHire";
    greaterThan.value2.value = "2019-01-01T00:00";
    node.expression.expression = greaterThan;

    node.trueNode!.setupResult(treeRule.getInputDefinition(), treeRule.getRuleResult());
    node.trueNode!.expression.value = true;

    node = node.falseNode!;
    node.setupEvaluation(treeRule.getInputDefinition());

    notExp = new NotExpression();

    exists = new ExistsExpression();
    exists.dataPath = "disciplinaryActionsHistory";

    notExp.value1.subExpression = exists;
    node.expression.expression = notExp;

    node.trueNode!.setupResult(treeRule.getInputDefinition(), treeRule.getRuleResult());
    node.trueNode!.expression.value = true;

    node = node.falseNode!;
    node.setupEvaluation(treeRule.getInputDefinition());

    let containExpression = new StringContainsExpression();
    containExpression.value1.variableName = "salaryBand";
    containExpression.value2.value = "45C";

    node.expression.expression = containExpression;

    node.falseNode!.setupResult(treeRule.getInputDefinition(), treeRule.getRuleResult());
    node.falseNode!.expression.value = true;

    node = node.trueNode!;
    node.setupEvaluation(treeRule.getInputDefinition());

    isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "fullTime";
    node.expression.expression = isTrue;

    node.falseNode!.setupResult(treeRule.getInputDefinition(), treeRule.getRuleResult());
    node.falseNode!.expression.value = false;

    node.trueNode!.setupResult(treeRule.getInputDefinition(), treeRule.getRuleResult());
    node.trueNode!.expression.value = true;

    return treeRule;
};
